module.exports = __webpack_public_path__ + "static/media/firebaseDatabase.405e4314.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/firebaseDatabase.png
// module id = 756
// module chunks = 1 3